module.exports = __webpack_public_path__ + "static/img/1089_small.63804a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1089_small.png
// module id = WVrL
// module chunks = 1